"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageQQZQ = void 0;
var react_1 = __importStar(require("react"));
var crumbs_1 = require("../crumbs");
require("./qqzq.less");
var toast_1 = require("./shared/modal/toast");
var dayjs_1 = __importDefault(require("dayjs"));
/**
 * 全球债券
 * @returns
 */
function PageQQZQ() {
    return (react_1.default.createElement("div", { className: "qqzq" },
        react_1.default.createElement(crumbs_1.CrumbsWithRefreshLine, null),
        react_1.default.createElement(QQZQTable, null)));
}
exports.PageQQZQ = PageQQZQ;
function QQZQTable() {
    var _this = this;
    var _a = (0, react_1.useState)([]), list = _a[0], setList = _a[1];
    var _b = (0, react_1.useState)("price"), sortitem = _b[0], setSortItem = _b[1];
    var _c = (0, react_1.useState)(""), sortType = _c[0], setSortType = _c[1];
    var _d = (0, react_1.useState)(false), showtoast = _d[0], setShowToast = _d[1];
    (0, react_1.useEffect)(function () {
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var back, arr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getData()];
                    case 1:
                        back = _a.sent();
                        arr = getDefaultOrderList(back);
                        setList(arr);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, []);
    var getData = function () { return __awaiter(_this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, $.ajax({
                        url: './api/qqzq.js',
                        type: 'GET',
                        dataType: 'script'
                    })];
                case 1:
                    _a.sent();
                    if (window.data && window.data instanceof Array) {
                        res = formatQQZSData(window.data);
                        return [2 /*return*/, res || []];
                    }
                    return [2 /*return*/, []];
            }
        });
    }); };
    var sortFun = function (name) {
        var s_type = getSortType(sortType);
        if (name != sortitem) {
            s_type = 'desc';
        }
        var res = getSortData(list, name, s_type);
        setSortItem(name);
        setSortType(s_type);
        setList(res);
    };
    var showToast = function (e) {
        e.preventDefault();
        setShowToast(true);
        setTimeout(function () {
            setShowToast(false);
        }, 1500);
    };
    return (react_1.default.createElement("div", { className: "qqzq_table" },
        react_1.default.createElement("table", { className: "quotetable_m" },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", null, "\u5E8F\u53F7"),
                    react_1.default.createElement("th", null, "\u540D\u79F0"),
                    react_1.default.createElement("th", null, "\u54C1\u79CD\u540D\u79F0"),
                    react_1.default.createElement("th", null, "\u6570\u636E\u66F4\u65B0\u65F6\u95F4"),
                    react_1.default.createElement("th", { className: "sort", onClick: function (e) { e.preventDefault(); sortFun('price'); } },
                        "\u6700\u65B0\u4EF7",
                        sortitem == 'price' && react_1.default.createElement(react_1.default.Fragment, null, sortType == 'desc' ? react_1.default.createElement("span", { className: "icon_down" }) : sortType == 'asc' ? react_1.default.createElement("span", { className: "icon_up" }) : "")),
                    react_1.default.createElement("th", { className: "sort", onClick: function (e) { e.preventDefault(); sortFun('percent'); } },
                        "\u6DA8\u8DCC\u5E45",
                        sortitem == 'percent' && react_1.default.createElement(react_1.default.Fragment, null, sortType == 'desc' ? react_1.default.createElement("span", { className: "icon_down" }) : sortType == 'asc' ? react_1.default.createElement("span", { className: "icon_up" }) : "")))),
            react_1.default.createElement("tbody", null, list && list.map(function (v, i) {
                var color = Number(v.percent) > 0 ? "red" : Number(v.percent) < 0 ? "green" : "";
                var fixed_num = v.iszq ? 3 : 2;
                return (react_1.default.createElement("tr", { key: i },
                    react_1.default.createElement("td", null, i + 1),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement("a", { hrefLang: "javascript:void(0);", target: "_self", onClick: function (e) { showToast(e); } }, v.name),
                        v.isqh && react_1.default.createElement("span", { className: "tip" })),
                    react_1.default.createElement("td", null, v.pzname),
                    react_1.default.createElement("td", null, v.showtime),
                    react_1.default.createElement("td", { className: color }, v.price == '-' ? '-' : v.price.toFixed(fixed_num)),
                    react_1.default.createElement("td", { className: color }, v.percent == '-' ? '-' : v.percent.toFixed(2) + '%')));
            }))),
        showtoast && react_1.default.createElement(toast_1.Toast, null,
            react_1.default.createElement(react_1.default.Fragment, null, "\u8BE5\u54C1\u79CD\u6682\u65E0\u8D70\u52BF\u5206\u6790"))));
}
// 品种
var pz_qh = ['US30YT_B', 'US10YT_N', 'US5YT_N', 'US2YT_N', 'EU_B', 'UK_B', 'JP_B'];
var pz_zq = ['US10Y_B', 'CN10Y_B', 'US2Y_B', 'CN2Y_B', 'US5Y_B', 'CN5Y_B', 'UK10Y_B', 'GM10Y_B', 'FH10Y_B', 'SP10Y_B', 'ITA10Y_B', 'GRC10Y_B', 'ID10Y_B', 'JP10Y_B'];
/**
 * 品种名称
 */
function getPZname(code) {
    if (pz_qh.indexOf(code) > -1) {
        return "期货";
    }
    if (pz_zq.indexOf(code) > -1) {
        return "债券收益率";
    }
    return "";
}
/**
 * 全球指数数据格式化
 */
function formatQQZSData(arr) {
    if (!arr || arr.length < 2) {
        return [];
    }
    try {
        var fileds = arr[0].split(",");
        var index_code_1 = fileds.indexOf('code');
        var index_name_1 = fileds.indexOf('name');
        var index_date_1 = fileds.indexOf('date');
        var index_time_1 = fileds.indexOf('time');
        var index_price_1 = fileds.indexOf('new');
        var index_percent_1 = fileds.indexOf('percent');
        var back = arr.slice(1).map(function (v) {
            var temp = v.split(',');
            var code = temp[index_code_1];
            var name = temp[index_name_1];
            var pzname = getPZname(code);
            var showtime = getUpdateTime(temp[index_date_1].toString(), temp[index_time_1].toString());
            return {
                code: code,
                name: name,
                pzname: pzname,
                showtime: showtime,
                price: isNaN(Number(temp[index_price_1])) ? '-' : Number(temp[index_price_1]),
                percent: isNaN(Number(temp[index_percent_1])) ? '-' : Number(temp[index_percent_1]),
                iszq: pz_zq.indexOf(code) > -1,
                isqh: pz_qh.indexOf(code) > -1
            };
        });
        return back || [];
    }
    catch (error) {
        return [];
    }
}
/**
 * 获取排序后数组
 */
function getSortData(arr, name, type) {
    try {
        var back = arr;
        // sheng
        if (type == 'asc') {
            back = arr.sort(function (a, b) {
                var v1 = a[name];
                var v2 = b[name];
                if (v1 == '-')
                    v1 = 0;
                if (v2 == '-')
                    v2 = 0;
                return v1 - v2;
            });
        }
        // jiang
        if (type == 'desc') {
            back = arr.sort(function (a, b) {
                var v1 = a[name];
                var v2 = b[name];
                if (v1 == '-')
                    v1 = 0;
                if (v2 == '-')
                    v2 = 0;
                return v2 - v1;
            });
        }
        return back;
    }
    catch (error) {
        return arr;
    }
}
function getSortType(str) {
    if (str == 'desc') {
        return 'asc';
    }
    if (str == 'asc') {
        return 'desc';
    }
    return 'desc';
}
/**
 * 更新时间
 */
function getUpdateTime(date, time) {
    var timestr = time.length == 6 ? time : time.length == 5 ? '0' + time : '00' + time;
    if (date.length < 8) {
        return "";
    }
    var back = "";
    if ((0, dayjs_1.default)().format("YYYYMMDD") == date) {
        back = timestr.replace(/(?!^)(?=(\d{2})+$)/g, ':'); // HH:mm:ss
    }
    else if ((0, dayjs_1.default)().format("YYYY") != date.substring(0, 4)) {
        back = (0, dayjs_1.default)(date).format('YYYY-MM-DD');
    }
    else {
        // back = date.replace(/^(\d{4})/g,"").replace(/(?!^)(?=(\d{2})+$)/g, '-')  // mm-dd
        back = (0, dayjs_1.default)(date).format("MM-DD");
    }
    return back;
}
/** 默认排序 */
var default_order = ['US10Y_B', 'CN10Y_B', 'US2Y_B', 'CN2Y_B', 'US5Y_B', 'CN5Y_B', 'UK10Y_B', 'GM10Y_B', 'FH10Y_B', 'SP10Y_B', 'ITA10Y_B', 'GRC10Y_B', 'ID10Y_B', 'JP10Y_B', 'US30YT_B', 'US10YT_N', 'US5YT_N', 'US2YT_N', 'EU_B', 'UK_B', 'JP_B'];
function getDefaultOrderList(list) {
    return list.sort(function (v1, v2) {
        return default_order.findIndex(function (v) {
            return v == v1.code;
        }) - default_order.findIndex(function (v) {
            return v == v2.code;
        });
    });
}
